export default function CareerRequirements(props) {
    const { isEnglish, features } = props
    return (
        <div className="px-4 sm:px-20 py-24 rounded-t-xl sm:rounded-none bg-gray-50">
            <div className="mx-auto max-w-7xl px-4 lg:px-8">
                <p className="sm:mb-2 text-md sm:text-lg text-brand-600 font-semibold">{isEnglish ? "Working as a Dentist in France" : 'Travailler comme dentiste chez Neomed'}</p>
                <h4 className="mt-2 sm:mt-1 text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{isEnglish ? "What's required to succeed" : "Ce qu'il vous faut pour réussir"}</h4>
                <div className="mx-auto mt-12 max-w-2xl lg:max-w-none">
                    <dl className="grid max-w-xl grid-cols-1 gap-x-12 gap-y-10 sm:gap-x-16 sm:gap-y-16 lg:max-w-none lg:grid-cols-3">
                        {features.map((feature) => (
                            <div key={feature.name} className="flex flex-col rounded-2xl bg-white border border-gray-100 p-6 sm:p-8 shadow-md transition-all duration-300 hover:shadow-lg hover:scale-[1.01]">
                                <dt className="text-xl sm:text-2xl font-bold leading-7 text-gray-900">
                                    <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-xl bg-brand-600">
                                        <feature.icon aria-hidden="true" className="h-5 w-5 text-white" />
                                    </div>
                                    {feature.name}
                                </dt>
                                <dd className="mt-3 flex flex-auto flex-col text-sm sm:text-base leading-7 text-gray-600">
                                    <p className="flex-auto">{feature.description}</p>
                                </dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>
        </div>
    )
}
